/**
 * @author Daniel Aguirre
 * @file constants.js
 * @description Educational element Constants
 */

// Generic actions
export const GET_ALL_EDUCATIONAL_ELEMENTS =
  'Profile/GET_ALL_EDUCATIONAL_ELEMENTS';
export const GET_EDUCATIONAL_ELEMENT_BY_ID =
  'Profile/GET_EDUCATIONAL_ELEMENT_BY_ID';
export const CREATE_EDUCATIONAL_ELEMENT = 'Profile/CREATE_EDUCATIONAL_ELEMENT';
export const UPDATE_EDUCATIONAL_ELEMENT = 'Profile/UPDATE_EDUCATIONAL_ELEMENT';
export const DELETE_EDUCATIONAL_ELEMENT_BY_ID =
  'Profile/DELETE_EDUCATIONAL_ELEMENT_BY_ID';
export const GET_EDUCATIONAL_ELEMENT_BY_CATEGORY_ID =
  'Profile/GET_EDUCATIONAL_ELEMENT_BY_CATEGORY_ID';
